import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

// Define the GraphQL query for fetching dive certificate details
const getDiveCertificatesQuery = graphql(/* GraphQL */ `
  query diveCertificatesByUserId($userId: String!) {
    diveCertificatesByUserId(userId: $userId) {
      certificateId
      userId
      certificateLevel
      certifyingAgency
      certificateNumber
    }
  }
`);

// Custom hook for fetching dive certificate details
const useGetDiveCertificates = (userId: string, enabled = true) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    diveCertificatesByUserId: {
      certificateId: number;
      userId: string;
      certificateLevel: string;
      certifyingAgency: string;
      certificateNumber: string;
    } | null;
  }>({
    queryKey: ['diveCertificates', userId],
    queryFn: async () =>
      graphqlRequest(
        getDiveCertificatesQuery,
        { userId },
        enabled && isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: enabled && isAuthenticated,
    retry: shouldRetryQuery,
  });

  const diveCertificates = data?.diveCertificatesByUserId;

  return {
    diveCertificates,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetDiveCertificates;
